import { KeyValueChanges, KeyValueDiffer, KeyValueDiffers, Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: "mapvalues",
    pure: false,
    standalone: false
})

export class MapvaluesPipe<K, V> implements PipeTransform {

  private differ!: KeyValueDiffer<K, V>
  private result: Array<V> = []

  constructor(private readonly differs: KeyValueDiffers) {}

  transform(map?: Map<K, V>): Array<V> | null {
    if (! map || (! (map instanceof Map) && typeof map !== 'object')) {
      return null
    }

    this.differ ??= this.differs.find(map).create()
    const differChanges: KeyValueChanges<K, V> | null = this.differ.diff(map as any)

    if (differChanges) {
      this.result = Array.from(map.values())
    }

    return this.result
  }
}
